import './Portfolio.css';

const customers = [
  { name: 'Zomato Hyperpure', file: 'Zomato Hyperpure.jpg' },
  { name: 'Swiggy Assure', file: 'Swiggy Assure.png' },
  { name: 'BigBasket', file: 'Big Basket.png' },
  { name: 'Udaan', file: 'Udaan.png' },
  { name: 'Nilgiris', file: 'Nilgiris.png' },
  { name: 'A2b', file: 'A2b.jpg', imgHeight: '38px' },
];

const businesses = [
  {
    name: 'Vilathikulam Processing Centre',
    location: 'Vilathikulam, Tamil Nadu',
    tag: 'Agri-Processing',
    desc: 'Our flagship operation — a government-facilitated processing unit for chillies, coriander seeds, and other spices. We do extensive quality-based processing to ensure that the right quality is matched with the right customer. As this facility reached capacity, we expanded operations to 4 other nearby villages (Vedapatti, Karisal Kulam, Nagalapuram, and V. Pudur) in a decentralized, village-level scalability model.',
    img: '/images/ppc_outside.jpg',
    customers,
  },
  {
    name: 'Kovilpatti Processing & Distribution Center',
    location: 'Kovilpatti, Tamil Nadu',
    tag: 'Agri-Processing',
    desc: 'Our second processing center and affiliated distribution business to serve retail markets across South Tamil Nadu. Regular supply to supermarkets, hyper marts, "maligai" stores (grocery shops), and "annachi" shops (mom-and-pop stores).',
    img: '/images/vehicle_loading.jpg',
    customers: [],
  },
  {
    name: 'Erode Distribution & Retail Hub',
    location: 'Erode, Tamil Nadu',
    tag: 'Distribution',
    desc: 'A companion distribution operation in Erode, expanding our retail network to markets in West Tamil Nadu. Covering restaurants, supermarkets, hyper marts, "maligai" stores, and other general trade.',
    img: '/images/chilli_packets_3.jpg',
    customers: [],
  },
];

export default function Portfolio() {
  return (
    <section className="portfolio" id="portfolio">
      <div className="portfolio-inner">
        <p className="section-label">Current Businesses</p>
        <h2 className="section-title">Where we operate today.</h2>
        <div className="divider" />
        <div className="portfolio-list">
          {businesses.map((b, i) => (
            <div className="portfolio-item" key={b.name}>
              <div className="portfolio-img">
                <img src={b.img} alt={b.name} />
              </div>
              <div className="portfolio-content">
                <div className="portfolio-meta">
                  <span className="portfolio-tag">{b.tag}</span>
                  <span className="portfolio-location">{b.location}</span>
                </div>
                <h3 className="portfolio-name">{b.name}</h3>
                <p className="portfolio-desc">{b.desc}</p>
                {b.customers.length > 0 && (
                  <div className="portfolio-customers">
                    <p className="customers-label">Supplying to well-known names in the food industry including</p>
                    <div className="customers-logos">
                      {b.customers.map(c => (
                        <div key={c.name} className="customer-logo-box" title={c.name}>
                          <img
                            src={`/images/logos/${c.file}`}
                            alt={c.name}
                            className="customer-logo-img"
                            style={c.imgHeight ? { height: c.imgHeight } : undefined}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
